/**
 * O que aparece no lugar do número do título.
 *
 * Um título que o ERP nunca apropriou não tem número de título para mostrar: o
 * MEGA numera a mãe de um agrupamento com um contador por fornecedor, então
 * "1/001" não diz nada sobre qual AP é aquela. Nesses casos a linha se declara
 * "Item sem apropriação" e a AP fica na observação, ao lado.
 *
 * O campo ausente vale como apropriado — é o caso dos títulos do Sienge e de
 * tudo o que foi gravado antes desta versão.
 */
export const UNAPPROPRIATED_LABEL = "Item sem apropriação";

export const titleIdentifier = (row) =>
  row?.appropriated === false ? UNAPPROPRIATED_LABEL : row?.id;

const TitleIdentifier = ({ row }) => <>{titleIdentifier(row)}</>;

export default TitleIdentifier;
